import React, { Component } from 'react'
import { observer } from 'mobx-react'
import * as R from 'ramda'
import i18n from 'i18next'
import Select from '../form/Select'
import Input from '../form/Input'
import CheckboxGroup from '../form/CheckboxGroup'
import Button from '../../UniformComponents/Button'

import './mergeFields.scss'

@observer
class MergeFields extends Component {
    defaultPortfolio = {
        value: '*',
        label: 'Any portfolio',
    }

    defaultDivision = {
        value: '*',
        label: 'Any division',
    }

    constructor(props) {
        super(props)

        const { match, store } = props
        const { mergefieldId } = match.params

        this.state = {
            stage: 1,
            clients: [],
            industries: [],
            divisions: [],
            portfolios: [],
            surveyTypes: [],
            productTypes: [],
            respondentTypes: [],
            response: {},
            fields: {},
            typeToIndustry: {},
            ready: false,
        }

        store.breadcrumps = [
            {
                name: 'mergefields',
                url: '/intranet/mergefields',
                title: 'MergeFields',
            },
            {
                name: 'mergeFieldId',
                url: `/intranet/mergefields/${mergefieldId}`,
                title: String(mergefieldId),
            },
        ]
    }

    async componentDidMount() {
        const { match, store } = this.props
        const { mergefieldId } = match.params

        if (mergefieldId !== '0') {
            const mergeFieldData = await store.http.get(`/mergefield/${mergefieldId}`)

            const [clients, prodMap] = await Promise.all(
                [
                    this.getClients(),
                    this.getProdMap(),
                ],
            )

            await this.getClientSpecificTypes(mergeFieldData.clientId, () => {
                const response = this.hydrateResponse(mergeFieldData, this.state)
                this.setState({
                    clients,
                    industries: Object.values(prodMap.industries),
                    surveyTypes: Object.values(prodMap.surveyTypes),
                    respondentTypes: Object.values(prodMap.respondentTypes),
                    productTypes: Object.values(prodMap.productTypes),
                    response,
                    typeToIndustry: prodMap.typeToIndustry,
                    ready: true,
                    stage: 11,
                })
            })

            return
        }

        const [clients, prodMap] = await Promise.all(
            [
                this.getClients(),
                this.getProdMap(),
            ],
        )

        this.setState({
            clients,
            industries: Object.values(prodMap.industries),
            surveyTypes: Object.values(prodMap.surveyTypes),
            respondentTypes: Object.values(prodMap.respondentTypes),
            productTypes: Object.values(prodMap.productTypes),
            typeToIndustry: prodMap.typeToIndustry,
            ready: true,
            divisions: [],
            portfolios: [],
        })
    }

    hydrateResponse = (mergeFieldData, { divisions, portfolios }) => ({
        client: mergeFieldData.clientId,
        type: mergeFieldData.oid,
        mergefieldType: mergeFieldData.mergefieldType,
        industry: mergeFieldData.industry,
        division: divisions.filter(({ value }) => mergeFieldData.division.includes(value)),
        portfolio: portfolios.filter(({ value }) => mergeFieldData.portfolio.includes(value)),
        productType: mergeFieldData.productType,
        surveyType: mergeFieldData.surveyType,
        respondentType: mergeFieldData.respondentType,
        mergeFieldName: mergeFieldData.name,
        mergeFieldDescription: mergeFieldData.description,
        options: mergeFieldData.options ? JSON.parse(mergeFieldData.options) : undefined,
    })

    getClientSpecificTypes = async (clientId, callback) => {
        const { store } = this.props
        if (!clientId) {
            this.setState({
                divisions: [this.defaultDivision],
                portfolios: [this.defaultPortfolio],
            }, callback)
            return
        }
        const [industries, surveyTypes, divisions, portfolios] = await Promise.all([
            store.http.get(`/client/${clientId}/industry`),
            store.http.get(`/client/${clientId}/surveytype`),
            store.http.get(`/division/client/${clientId}`),
            store.http.get(`/portfolio/client/${clientId}`),
        ])

        this.setState({
            clientSpecificTypes: {
                surveyTypes,
                industries: industries.map((i) => i.code),
            },
            divisions: [this.defaultDivision].concat(divisions.map(({ divisionId, name }) => ({
                value: String(divisionId),
                label: name,
            }))),
            portfolios: [this.defaultPortfolio].concat(portfolios.map(({ portfolioId, name, divisionId, industry }) => ({
                value: String(portfolioId),
                label: name,
                divisionId: String(divisionId),
                industry,
            }))),
        }, callback)
    }

    getFilteredResponentTypes = () => {
        const { respondentTypes, response } = this.state

        if (response.type === 6 || !response.surveyType || !response.industry) return []

        return respondentTypes.filter((rt) => rt.industry === response.industry
                    && [...rt.surveyTypes].some((st) => response.surveyType.includes(st)))
    }

    filteredPortfolios = (portfolios, response) => {
        const selectedDivisions = R.pathOr([], ['division'], response)
            .reduce((a, { value }) => a.add(value), new Set())

        console.log('filteredPortfolios', portfolios)
        return portfolios.filter(({ divisionId, industry, value }) => (
            value === '*'
            || (
                response.industry === industry
                && (
                    selectedDivisions.size === 0
                    || selectedDivisions.has(divisionId)
                    || selectedDivisions.has('*')
                )
            )
        ))
    }

    stages = () => {
        const {
            clients, industries, response, clientSpecificTypes, divisions, portfolios,
        } = this.state

        return [
            {
                type: 'select',
                title: 'Which client should this appear for?',
                options: clients,
                name: 'client',
                promise: this.getClientSpecificTypes,
                notmandatory: true,
                fieldResets: (responseClone) => {
                    if (responseClone.division) responseClone.division = []
                    if (responseClone.portfolio) responseClone.portfolio = []
                    if (responseClone.surveyType) responseClone.surveyType = []
                    if (responseClone.industry) responseClone.industry = ''

                    console.log('fieldReset client', responseClone)
                },
            },
            {
                type: 'select',
                title: 'Should this merge field be collected when creating / editing the PRODUCT or SURVEY?',
                options: [{ label: 'Product', value: 6 }, { label: 'Survey', value: 7 }],
                name: 'type',
                fieldResets: (responseClone) => {
                    if (responseClone.surveyType) responseClone.surveyType = []
                    if (responseClone.respondentType) responseClone.respondentType = []
                },
            },
            {
                type: 'select',
                title: 'Is this a drop down or open question',
                options: [{ label: 'Dropdown', value: 'SB' }, { label: 'Open', value: 'TX' }],
                name: 'mergefieldType',
                fieldResets: (responseClone) => {
                    if (responseClone.options) responseClone.options = []
                },
            },
            {
                type: 'options',
                title: 'Please enter your dropdown options:',
                name: 'options',
                hide: response.mergefieldType !== 'SB',
            },
            {
                type: 'select',
                title: 'What industry is this for?',
                options: response.client
                    ? industries.filter((i) => clientSpecificTypes.industries.includes(i.value))
                    : industries,
                name: 'industry',
                fieldResets: (responseClone) => {
                    if (responseClone.portfolio) {
                        responseClone.portfolio = this.filteredPortfolios(responseClone.portfolio, responseClone)
                    }
                    if (responseClone.surveyType) responseClone.surveyType = []
                    if (responseClone.respondentType) responseClone.respondentType = []
                    if (responseClone.productType) responseClone.productType = []
                },
            },
            {
                type: 'select',
                title: 'What division is this for?',
                options: divisions,
                name: 'division',
                notmandatory: true,
                placeHolder: 'Any division',
                isMulti: true,
                fieldResets: (responseClone) => {
                    if (responseClone.portfolio) {
                        responseClone.portfolio = this.filteredPortfolios(responseClone.portfolio, responseClone)
                    }
                },
            },
            {
                type: 'select',
                title: 'What portfolio is this for?',
                options: this.filteredPortfolios(portfolios, response),
                isMulti: true,
                notmandatory: true,
                placeHolder: 'Any portfolio',
                name: 'portfolio',
            },
            {
                type: 'multiCheckbox',
                title: 'What product type should this appear for?',
                options: this.getFilteredProductTypes(),
                name: 'productType',
            },
            {
                type: 'multiCheckbox',
                title: 'What type of survey should this appear on?',
                options: this.getFilteredSurveyTypes(),
                hide: response.type === 6,
                name: 'surveyType',
            },
            {
                type: 'multiCheckbox',
                title: 'Which Respondent is this for?',
                options: this.getFilteredResponentTypes(),
                hide: response.type === 6,
                name: 'respondentType',
            },
        ]
    }

    getClients = async () => {
        const { store } = this.props
        const userAccountsRes = await store.http.get('/client')

        return [{ value: '', label: 'All Clients' }].concat(userAccountsRes.clients
            .map((c) => ({ value: c.clientId, label: `${c.name} - ${c.clientId}` })))
    }

    getProdMap = async () => {
        const { store } = this.props
        const productMaps = await store.http.get('/productmap')

        const prodMap = {
            typeToIndustry: {},
            industries: {},
            surveyTypes: {},
            respondentTypes: {},
            productTypes: {},
        }

        productMaps.forEach((map) => {
            if (!prodMap.typeToIndustry[map.industrycode]) prodMap.typeToIndustry[map.industrycode] = {}

            if (!prodMap.typeToIndustry[map.industrycode][map.producttypecode]) {
                prodMap.typeToIndustry[map.industrycode][map.producttypecode] = []
            }

            if (!prodMap.typeToIndustry[map.industrycode][map.producttypecode]
                .includes(map.surveytypecode)) {
                prodMap.typeToIndustry[map.industrycode][map.producttypecode]
                    .push(map.surveytypecode)
            }

            if (!prodMap.industries[map.industrycode]) {
                prodMap.industries[map.industrycode] = {
                    label: map.industryname,
                    value: map.industrycode,
                }
            }

            if (!prodMap.surveyTypes[map.surveytypecode]) {
                prodMap.surveyTypes[map.surveytypecode] = {
                    label: map.surveytypename,
                    value: map.surveytypecode,
                }
            }

            if (!prodMap.respondentTypes[map.respondenttypecode]) {
                prodMap.respondentTypes[map.respondenttypecode] = {
                    label: map.respondenttypename,
                    value: map.respondenttypecode,
                    industry: map.industrycode,
                    surveyTypes: new Set([map.surveytypecode]),
                }
            } else {
                prodMap.respondentTypes[map.respondenttypecode].surveyTypes.add(map.surveytypecode)
            }

            if (!prodMap.productTypes[map.producttypecode]) {
                prodMap.productTypes[map.producttypecode] = {
                    label: map.producttypename.replace(`${map.industryname} - `, ''),
                    value: map.producttypecode,
                }
            }
        })

        return prodMap
    }

    getFilteredSurveyTypes = () => {
        const {
            surveyTypes, typeToIndustry, response, clientSpecificTypes,
        } = this.state

        const allowedTypes = []

        if (!response.productType || !response.industry) return

        response.productType.forEach((pt) => {
            if (typeToIndustry[response.industry][pt]) {
                if (!response.client) {
                    allowedTypes.push(...typeToIndustry[response.industry][pt])
                } else {
                    allowedTypes.push(...typeToIndustry[response.industry][pt]
                        .filter((s) => clientSpecificTypes.surveyTypes.includes(s)))
                }
            }
        })

        return surveyTypes.filter((st) => allowedTypes.includes(st.value))
    }

    getFilteredProductTypes = () => {
        const { productTypes, typeToIndustry, response } = this.state

        if (!response.industry) return

        const allowedTypes = Object.keys(typeToIndustry[response.industry])

        return productTypes.filter((pt) => allowedTypes.includes(pt.value))
    }

    onchange = async (field, promise, fieldResets, isMulti = false) => {
        const { response, stage } = this.state
        if (promise) await promise(field.value)

        console.log('onchange', field)

        const responseClone = R.clone(response)
        const increment = (Object.prototype.hasOwnProperty.call(responseClone, field.name) ? 0 : 1)
        if (isMulti && R.pathOr([], [field.name], responseClone).some(({ value }) => value === '*')) {
            responseClone[field.name] = field.value.filter(({ value }) => value !== '*')
        } else if (isMulti) {
            responseClone[field.name] = field.value.some(({ value }) => value === '*')
                ? field.value.filter(({ value }) => value === '*')
                : field.value
        } else {
            responseClone[field.name] = field.value
        }

        if (fieldResets) fieldResets(responseClone)

        this.setState({
            stage: stage + increment,
            response: { ...responseClone },
        })
    }

    changeOptions = (field, index) => {
        const { store } = this.props
        const { response } = this.state

        const newOptions = R.clone(response.options)
        newOptions[index] = { en_GB: field.value }

        this.setState({ response: { ...response, options: newOptions } })
    }

    addNewOption = () => {
        const { response, stage } = this.state

        const newOptions = R.clone(R.pathOr([], ['options'], response))

        newOptions.push('')

        this.setState({
            stage: stage + (response.options ? 0 : 1),
            response: { ...response, options: newOptions },
        })
    }

    removeOption = (index) => {
        const { response } = this.state

        const newOptions = R.clone(response.options)

        newOptions.splice(index, 1)

        this.setState({ response: { ...response, options: newOptions } })
    }

    renderStages = () => {
        const { store } = this.props
        const { stage, response } = this.state
        const stages = R.slice(0, stage, this.stages().filter(({ hide }) => !hide))

        return stages.map((s) => {
            switch (s.type) {
                case 'select':
                    const value = s.isMulti
                        ? R.pathOr([], [s.name], response)
                        : R.or(s.options.find((o) => o.value === response[s.name]), '')
                    console.log('value', s.name, value)
                    return (
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div className="subHeading">{s.title}</div>
                            <Select
                                options={s.options}
                                onBlur={(field) => this.onchange(field, s.promise, s.fieldResets, s.isMulti)}
                                name={s.name}
                                value={value}
                                isMandatory={!s.notmandatory}
                                placeholder={s.placeHolder}
                                register={this.register}
                                unregister={this.unregister}
                                isMulti={s.isMulti}
                                blurOnClear
                                key={s.name}
                            />
                        </div>
                    )
                case 'multiCheckbox':
                    return (
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div className="subHeading">{s.title}</div>
                            <CheckboxGroup
                                options={s.options || []}
                                onBlur={(field) => this.onchange(field, s.promise, s.fieldResets)}
                                name={s.name}
                                defaultChecked={response[s.name] || []}
                                returnValueUnchanged
                                isMandatory
                                refreshOnRender
                                register={this.register}
                                unregister={this.unregister}
                                key={s.name}
                            />
                        </div>
                    )
                case 'options':
                    return (
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div className="subHeading">{s.title}</div>
                            <div className="dropdownOptions">
                                {response.options && response.options.map((o, index) => (
                                    <div className="dropdownOption">
                                        <Input
                                            name="option"
                                            onBlur={(field) => this.changeOptions(field, index)}
                                            defaultValue={o.en_GB}
                                            placeholder="Please enter a dropdown option ..."
                                            key={`option${index}${o.en_GB}`}
                                        />
                                        <button
                                            key={`delete${index}${o.en_GB}`}
                                            onClick={() => this.removeOption(index)}
                                        >
                                            <i className="far fa-trash-alt" />
                                        </button>
                                    </div>
                                ))}
                                <Button onClick={this.addNewOption}>Add New Option</Button>
                            </div>
                        </div>
                    )
                default:
                    return <div />
            }
        })
    }

    buildBody = () => {
        const { response } = this.state
        const { match } = this.props
        const { mergefieldId } = match.params

        return JSON.stringify({
            mergefieldId: parseInt(mergefieldId, 10),
            mergefieldType: response.mergefieldType,
            oid: response.type,
            clientId: response.client ? parseInt(response.client, 10) : undefined,
            industry: response.industry,
            division: R.pathOr(this.defaultDivision, ['division'], response).map(({ value }) => value),
            portfolio: R.pathOr(this.defaultPortfolio, ['portfolio'], response).map(({ value }) => value),
            productType: response.productType,
            surveyType: response.type === 7 ? response.surveyType : undefined,
            respondentType: response.type === 7 ? response.respondentType : undefined,
            name: response.mergeFieldName,
            description: response.mergeFieldDescription,
            options: response.options ? JSON.stringify(response.options) : undefined,

        })
    }

    register = (name, validate) => {
        const { fields } = this.state
        fields[name] = validate
    }

    unregister = (name) => {
        const { fields } = this.state
        Reflect.deleteProperty(fields, name)
    }

    submit = async () => {
        const { match, store, history } = this.props
        const { mergefieldId } = match.params

        const isValid = this.validationCheck()

        if (!isValid) {
            store.addNotification(null, 'Please provide a value for all fields', 'error')
            return
        }

        const body = this.buildBody()

        try {
            if (mergefieldId !== '0') {
                await store.http.put(`/mergefield/${mergefieldId}`, body)
                store.addNotification(null, 'merge field updated', 'success')
                history.push('/intranet/mergefields')
            } else {
                await store.http.post('/mergefield', body)
                store.addNotification(null, 'merge field added', 'success')
                history.push('/intranet/mergefields')
            }
        } catch (e) {
            if (mergefieldId === '0') {
                store.addNotification(null, 'Unable to add merge field', 'error')
            } else {
                store.addNotification(null, 'Unable to update merge field', 'error')
            }
        }
    }

    validationCheck = () => {
        const { response, fields } = this.state

        const isValid = Object.keys(fields)
            .map((key) => fields[key]({
                value: response[key],
                name: key,
            }, true))
            .every((valid) => valid)

        return isValid
    }

    validateName = ({ value }) => !(/\s|\[|\]/g.test(value))

    render() {
        const { ready, stage, response } = this.state
        return (
            <div id="mergeFields" className="mergeFields">
                <div>
                    {ready
                    && (
                        <div className="panel">
                            <div>
                                {this.renderStages()}
                                { stage > this.stages().filter((s) => !s.hide && !s.ignoreFromLength).length
                                && (
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <div className="subHeading">
                                            Please name the merge field.
                                            Do not include spaces and do not include
                                            &quot;[&quot; or &quot;]&quot;
                                        </div>
                                        <Input
                                            name="mergeFieldName"
                                            onBlur={this.onchange}
                                            isMandatory
                                            register={this.register}
                                            unregister={this.unregister}
                                            defaultValue={response.mergeFieldName}
                                            validate={this.validateName}
                                        />
                                        <div className="subHeading" style={{ marginTop: '10px' }}>
                                            Add a description of the merge field
                                        </div>
                                        <Input
                                            name="mergeFieldDescription"
                                            onBlur={this.onchange}
                                            isMandatory
                                            register={this.register}
                                            unregister={this.unregister}
                                            defaultValue={response.mergeFieldDescription}
                                        />
                                        <Button type="button" className="e-button" onClick={this.submit}>Submit</Button>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        )
    }
}

export default MergeFields
